<!--
INTELLECTUAL PROPERTY NOTICE
© Kaleida Ltd and/or Orbit Tickets Ltd. All rights reserved.
This file contains a combination of:
- Protected Intellectual Property owned by Kaleida Ltd; and
- Custom / Included Intellectual Property owned by the Customer,
and forms part of an application developed by Kaleida within the Platform.
Protected Intellectual Property may only be used as incorporated within applications developed by Kaleida within the Platform and must not be used, reproduced, adapted, or incorporated into any application developed by or on behalf of the Customer (being any application not developed by Kaleida), whether or not such application forms part of the Platform.
Custom / Included Intellectual Property may be used, reproduced, adapted, and incorporated into any application, system, or product developed by or on behalf of the Customer, whether or not such application forms part of the Platform, subject always to the terms of the agreement and provided that such use does not include or rely upon any Protected Intellectual Property of Kaleida Ltd.
For the avoidance of doubt, where separation between Protected Intellectual Property and Custom / Included Intellectual Property is unclear, this file shall be treated as containing Protected Intellectual Property.
-->
<!-- IP-NOTICE: MIXED -->
<form id="forgotPassword" [formGroup]="dataForm" (ngSubmit)="onForgotPasswordSubmit()" novalidate>
	<h3>Forgot Password</h3>

	<div class="flex-layout-row flex-layout-gap-10px">
		<button class="submitBtn" mat-raised-button type="submit" color="primary">Send Email</button>
		<button mat-raised-button (click)="onCancel($event)">Cancel</button>
	</div>

	<div>
		<div class="message-padding">
			<label class="display-label"> Please enter your email address and a link to reset your password will be emailed to you. </label>
		</div>

		<div>
			<mat-form-field>
				<mat-label>Email Address</mat-label><input formControlName="email" matInput autocomplete="disable-important" />
				<mat-error *ngIf="email.touched && email.errors?.required"> Email Address is required </mat-error>
				<mat-error *ngIf="email.touched && email.errors?.maxlength">Email Address must be no more than 254 characters</mat-error>
				<mat-error *ngIf="email.touched && email.errors?.pattern && !email.errors?.maxlength"
					>Email Address must be a correctly formatted email address</mat-error
				>
			</mat-form-field>
		</div>
	</div>
</form>
